<template>
  <div>
    <vx-card>
      <div class="tab-text">
        <el-row :gutter="20" type="flex" justify="space-around">
          <el-col :span="11">
            <el-form
              ref="form"
              label-width="30%"
              label-position="left"
              size="mini"
            >
              <el-form-item label="status">
                <p slot="label">
                  {{ $t("status") }}
                </p>
                <el-select
                  class="w-full"
                  v-model="value"
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  placeholder="Status"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="brand">
                <p slot="label">
                  {{ $t("brand") }}
                </p>
                <el-input v-model="brand" />
              </el-form-item>
            </el-form>
          </el-col>

          <el-col :span="11">
            <el-form
              ref="form"
              label-width="30%"
              label-position="left"
              size="mini"
            >
              <el-form-item label="YEAR SEASON">
                <p slot="label">
                  {{ $t("Year Season") }}
                </p>
                <el-select
                  class="w-full"
                  v-model="value"
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  placeholder="Year Season"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="SAMPEL CODE">
                <p slot="label">Sample Code</p>
                <el-input v-model="sample" />
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <div class="flex flex-row w-full">
          <el-button
            size="small"
            type="primary"
            v-if="!form.id"
            @click.prevent="clearData"
            >Clear Form</el-button
          >
          <el-button v-if="!form.id" size="small" type="primary"
            >Get Data</el-button
          >
        </div>
        <el-row>
          <el-col>
            <el-tabs>
              <el-tab-pane :label="$t('SPL')">
                <el-row>
                  <el-col>
                    <vxe-toolbar size="small"> </vxe-toolbar>
                    <vxe-table
                      size="mini"
                      :loading="loadingTable"
                      empty-text="Empty Data "
                      keep-source
                      border
                      resizable
                      show-overflow
                      show-footer
                      :footer-method="footerMethod"
                      ref="xTable"
                      :row-style="$$rowStyleDelete"
                      height="400"
                      row-key
                      highlight-hover-row
                      highlight-current-row
                      :row-config="{
                        isCurrent: true,
                        isHover: true,
                        height: 35,
                      }"
                      :column-config="{ resizable: true }"
                      :data="baca"
                      :mouse-config="{ selected: true }"
                      :checkbox-config="{
                        highlight: true,
                        range: true,
                        checkMethod: checkMethodBaca,
                      }"
                      :keyboard-config="{
                        isArrow: true,
                        isDel: true,
                        isEnter: true,
                        isTab: true,
                        isEdit: true,
                      }"
                      :edit-config="{
                        trigger: 'dblclick',
                        mode: 'cell',
                        showStatus: true,
                      }"
                      :scroll-y="{ mode: 'wheel' }"
                      @checkbox-all="getDataSelected"
                      @checkbox-change="getDataSelected"
                    >
                      <vxe-column
                        type="seq"
                        fixed="left"
                        width="60"
                      ></vxe-column>
                      <vxe-column
                        header-align="left"
                        align="left"
                        type="checkbox"
                        fixed="left"
                        width="60"
                      ></vxe-column>

                      <vxe-column
                        width="140"
                        align="center"
                        field="DELETE"
                        :title="$t('hapus')"
                        header-align="center"
                      >
                        <template v-slot:default="{ rowIndex, row }">
                          <el-button
                            v-on:click="detailtoisdeletedTrue(row)"
                            size="mini"
                            type="danger"
                          >
                            {{ $t("hapus") }}
                          </el-button>
                        </template>
                      </vxe-column>
                      <vxe-column
                        width="140"
                        align="center"
                        field="mmiContract"
                        title="MMI CONTRACT"
                        header-align="center"
                      >
                      </vxe-column>

                      <vxe-column
                        width="160"
                        align="left"
                        header-align="center"
                        field="ORDER NO/PO"
                        :title="$t('ORDER NO/PO').toUpperCase()"
                      >
                      </vxe-column>
                      <vxe-column
                        width="200"
                        align="left"
                        header-align="center"
                        field="year"
                        :title="$t('year').toUpperCase()"
                        :edit-render="{ autofocus: '.vxe-input--inner' }"
                      >
                      </vxe-column>

                      <vxe-column
                        width="100"
                        align="center"
                        header-align="center"
                        field="planning ssn"
                        :title="$t('planning ssn').toUpperCase()"
                        :edit-render="{ autofocus: '#autocomplete' }"
                      >
                      </vxe-column>
                      <vxe-column
                        width="100"
                        align="center"
                        header-align="center"
                        field="sample code"
                        :title="$t('sample code').toUpperCase()"
                      >
                      </vxe-column>
                      <vxe-column
                        width="100"
                        align="center"
                        header-align="center"
                        field="item code"
                        :title="$t('item code').toUpperCase()"
                      >
                      </vxe-column>
                      <vxe-column
                        width="100"
                        align="center"
                        header-align="center"
                        field="item"
                        :title="$t('item')"
                      >
                      </vxe-column>

                      <vxe-column
                        width="130"
                        align="center"
                        header-align="center"
                        field="order plan number"
                        :title="$t('order plan number').toUpperCase()"
                        :edit-render="{ autofocus: '#ijuls' }"
                      >
                      </vxe-column>

                      <vxe-column
                        width="150"
                        align="right"
                        header-align="center"
                        field="order qty"
                        :formatter="$$formatHarga"
                        :title="$t('order qty').toUpperCase()"
                        :edit-render="{ autofocus: '.vxe-input--inner' }"
                      >
                        <template #edit="{ row }">
                          <vxe-input
                            @input="totalEquals(row), susunDataBom()"
                            v-model="row.qtyOrder"
                            size="mini"
                            type="number"
                          ></vxe-input>
                        </template>
                      </vxe-column>
                      <vxe-column
                        width="150"
                        align="right"
                        :formatter="$$formatHarga"
                        field="size"
                        header-align="center"
                        :title="$t('size').toUpperCase()"
                        :edit-render="{ autofocus: '.vxe-input--inner' }"
                      >
                        <template #edit="{ row }">
                          <vxe-input
                            @input="totalEquals(row)"
                            v-model="row.size"
                            size="mini"
                            type="text"
                          ></vxe-input>
                        </template>
                      </vxe-column>
                      <vxe-column
                        width="150"
                        align="right"
                        header-align="center"
                        field="color"
                        :title="$t('color').toUpperCase()"
                        :formatter="$$formatHarga"
                      >
                      </vxe-column>
                    </vxe-table>
                  </el-col>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </div>

      <br />
    </vx-card>

    <vxe-modal
      :zIndex="10"
      v-model="vgonewModalDesign"
      title="Select Data Design Vgonew Data"
      width="80%"
      height="80%"
      show-zoom
      resize
    >
      <template #default>
        <vxe-toolbar>
          <template #buttons>
            <section>
              <p>Page/Halaman</p>
              <el-input-number
                label="Page/Halaman"
                placeholder="Page/Halaman"
                size="small"
                v-model="vgoPage"
                @change="handleChangePageVgo"
                :min="1"
                :max="10"
              ></el-input-number>
            </section>
          </template>
        </vxe-toolbar>
        <TableFull
          @sendData="vgonewSelectedData"
          :tableConfig="vgonewTableConfig"
        />
        <vxe-form title-align="right" title-width="60">
          <vxe-form-item align="center" span="24">
            <template #default>
              <vxe-button type="reset" @click="vgonewModalDesign = false">{{
                $t("close")
              }}</vxe-button>
            </template>
          </vxe-form-item>
        </vxe-form>
      </template>
    </vxe-modal>

    <SelectBarang
      ref="modalBarang"
      :jenis="['fg', 'bsj']"
      @sendData="handleSelected"
    />
    <SelectBarang
      ref="modalMaterial"
      :jenis="'material'"
      @sendData="handleSelectedMaterial"
    />
  </div>
</template>

<script>
import { getColumnHeaderWo } from "./helpWoFunction";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import Datepicker from "vuejs-datepicker";
import Table from "../../ui-elements/table/Table.vue";
import SelectBarang from "../../components/other/SelectBarang.vue";
import TableFull from "../../components/general/TableFull.vue";
import XLSX from "xlsx";
export default {
  props: {
    test: String,
    method: {
      type: Function,
    },
  },
  components: {
    SelectBarang,
    PerfectScrollbar,
    SweetModal,
    SweetModalTab,
    Datepicker,
    Table,
    TableFull,
  },
  data() {
    return {
      wotitle: this.$store.state.woNumberTitle,
      customsHead: {
        string1: "",
        string2: "",
      },
      vgoTypeOptions: [{ jenis: "VGO BARU" }, { jenis: "VGO LAMA" }],
      isSaveKomposisi: false,
      isSaveDescription: false,
      vgonewTableConfig: {
        bodyOverflow: false,
        headerOverflow: false,
        checkbox: false,
        select: true,
        selectTitle: "SELECT",
        selectButton: "CEK",

        tableHeight: 400,
        rowHeight: 35,
        tableData: [],
        size: "mini",

        column: [],
      },

      vgonewModalDesign: false,
      vgonewData: [],
      vgonewDataCompany: [],
      vgoPage: 1,
      dataCost: [],
      dataBom: [],
      optionsSatuan: [],
      optionsCurrency: [],
      loadingTableCost: false,
      loadingTableBom: false,
      loadingTableBarang: false,
      selectIndex: null,
      loadingTableTambahan: false,
      form: {
        vgoType: "VGO BARU",
        noPo: null,
        tanggal: new Date(),
        namaCustomer: null,
        kodeCustomer: null,
      },

      noInvoice: "",
      windowWidth: window.innerWidth,
      format: "yyyy-MM-dd",
      wodata: [],
      noUrut: "",
      index: "",
      optionsCustomer: [],

      shortcuts: [
        {
          text: "Today",
          onClick() {
            const date = new Date();
            // return a Date
            return date;
          },
        },
        {
          text: "Yesterday",
          onClick() {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            return date;
          },
        },
      ],
      dataJo: [],
      loadinTableJo: false,
      optionJenisPembelian: [
        {
          text: "CMT",
          value: "CMT",
        },
        {
          text: "FOB",
          value: "FOB",
        },
        {
          text: "SEWA",
          value: "SEWA",
        },
        {
          text: "BELI",
          value: "BELI",
        },
        {
          text: "PINJAM",
          value: "PINJAM",
        },
      ],
      optionStatus: [
        {
          text: "Active",
          value: "active",
        },
        {
          text: "Inactive",
          value: "inactive",
        },
      ],
      optionDokumen: [
        {
          text: "BC 23",
          value: "BC 23",
        },
        {
          text: "BC 40",
          value: "BC 40",
        },
        {
          text: "BC 262",
          value: "BC 262",
        },
        {
          text: "BC 27",
          value: "BC 27",
        },
      ],
      pilihMaterial: [],
      pilihMaterial2: [],
      submitted: false,
      searchQuery: "",
      dataBarangjadi: [],
      dataKomposisiWo: [],
      dataMaterial: [],
      selectBarangJadi: [],
      val: "",
      kurs: "",
      dokumenTambahan: [],
      jenisPembelian: "",
      asalBarang: "",
      pemasok: "",
      noreg: "",
      bl: "",
      bc1: "",

      noKontrak: "",
      noPo: "",
      noPendaftaran: "",

      jenisDokumen: "",
      ketOrder: "",
      tr: [],
      keterangan: "",
      status: "",
      optionKalkulasi: [],
      baca: [],
      radios1: "",
      tglKeluar: new Date().toISOString().split("T")[0],
      noSj: "",
      loadingTable: false,
      searchBarang: "",
      dataGetBarang: [],
      excelData: [],
    };
  },
  watch: {
    baca: {
      handler(data) {
        // console.log("🚀 ~ file: form.vue:1275 ~ handler ~ data:", data);
        if (!this.form.id) {
          localStorage.setItem("form-marketing-wo-list", JSON.stringify(data));
        }
      },
      deep: true,
    },
    form: {
      handler(data) {
        // console.log("🚀 ~ file: form.vue:1275 ~ handler ~ data:", data);
        if (!this.form.id) {
          localStorage.setItem("form-marketing-wo", JSON.stringify(data));
        }
      },
      deep: true,
    },
  },
  computed: {},
  methods: {
    async settingCustomsColm() {
      let get = await getColumnHeaderWo(this);

      if (get.content) {
        let val = get.content.valueKonf;
        let valSeparate = val.split(",");
        valSeparate.forEach((elm) => {
          let valElm = elm.split(":");
          if (valElm[1]) {
            this.customsHead[valElm[0].toLowerCase()] = valElm[1];
          }
        });
      }
    },
    clearData() {
      localStorage.removeItem("form-marketing-wo-list");
      localStorage.removeItem("form-marketing-wo");
      this.form = {
        noPo: null,
        tanggal: new Date(),
        namaCustomer: null,
        kodeCustomer: null,
      };
      this.baca = [];
      this.susunDataBom();
    },
    async deleteBom(row) {
      if (row.qtyReq > 0 || row.qtyPurchase > 0) {
        return this.notifValidasi(
          "Data tidak bisa dihapus karena sudah terpakai",
          true
        );
      }

      if (!row.id) {
        let find = this.baca.find((f) => f._X_ROW_KEY == row.rowHead);
        console.log(find);
        if (find) {
          find.listKalkulasi = find.listKalkulasi.filter(
            (f) => f._X_ROW_KEY != row._X_ROW_KEY
          );
        }
      } else {
        row.isDeleted = !row.isDeleted;
      }
      this.notifSuksesHapus();
      this.susunDataBom();
    },
    async checkWoStatus(row) {
      row.isLoading = true;
      let get = await this.$api.get("api/v1/marketing/wo/status", {
        params: { noReg: row.noReg },
      });
      row.isLoading = false;
      if (!get.data.content) {
        row.status = "Status tidak ditemukan";
      } else {
        row.status = get.data.content.status;
      }
    },
    async deleteDataAll() {
      if (!this.form.isMigration) {
        await this.checkWoStatus(this.form);
      } else {
        this.form.status = "BARU";
      }

      if (!["NEW", "BARU"].includes(this.form.status.toUpperCase())) {
        this.$notify({
          offset: 200,
          type: "warning",
          message: `${this.form.noPo} Status data has changed can not be deleted`,
          title: "WARNING",
        });
      } else {
        await this.$api.delete("api/v1/marketing/wo/deleteall/" + this.form.id);
        this.notifSuksesHapus();
        this.$router.push("/marketing/wo");
      }
    },
    handleChangePageVgo() {
      this.vgonewSearchDesign();
    },
    async perbaruiKomposisi() {
      for (let elm of this.baca) {
        elm.listKalkulasi = elm.listKalkulasi.filter(
          (f) => f.qtyReq || f.qtyPurchase
        );
      }
      for (let elm of this.baca) {
        let komposisi = await this.$api.get(
          "api/v1/marketing/komposisi/filter",
          {
            params: {
              kodeBarang: elm.kodeBarang,
              styleFg: elm.style,
              colorFg: elm.color,
              sizeFg: elm.size,
              specFg: elm.spec,
            },
          }
        );

        let newKomposisi = [...elm.listKalkulasi];
        for (let kalk of komposisi.data.content) {
          kalk.style = this.$$cleanVariable(kalk.style);
          kalk.color = this.$$cleanVariable(kalk.color);
          kalk.size = this.$$cleanVariable(kalk.size);
          kalk.spec = this.$$cleanVariable(kalk.spec);
          let cek = elm.listKalkulasi.find(
            (f) =>
              f.kodeMaterial + f.style + f.color + f.size + f.spec ==
              kalk.kodeMaterial +
                kalk.style +
                kalk.color +
                kalk.size +
                kalk.spec
          );
          if (cek) continue;

          delete kalk.id;

          kalk.kodeBarang = elm.kodeBarang;
          kalk.namaBarang = elm.namaBarang;
          kalk.satuanBarang = elm.satuan;
          newKomposisi.push(kalk);
        }
        elm.listKalkulasi = newKomposisi;
        elm.currency = "";
      }
      this.susunDataBom();
      this.notifikasiCustom(
        "success",
        "Berhasil",
        "Perbarui komposisi, silahkan simpan data"
      );
    },
    async previewFiles(e) {
      const file = e.target.files[0];
      var reader = new FileReader();
      this.excelData = [];
      let t = this;
      this.loadingTable = true;
      try {
        reader.onload = function (e) {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, {
            type: "array",
          });
          var firstSheet = workbook.SheetNames[0];
          const elements = XLSX.utils.sheet_to_json(
            workbook.Sheets[firstSheet]
          );
          // console.log("Excel read OK!");
          // console.log("Found " + elements.length + " elements");
          // console.log("JSON size", JSON.stringify(elements).length, "bytes");
          // console.log(elements);
          elements.forEach((el, i) => {
            t.excelData.push({
              kodeMaterial: el["MATERIAL CODE"],
              namaMaterial: el["MATERIAL DESCRIPTION"],
              satuan: el["MATERIAL UNIT"],
              style: el["MATERIAL STYLE"],
              color: el["MATERIAL COLOR"],
              size: el["MATERIAL SIZE"],
              total: el["QTY TOTAL"],
              keyData: el["KEY_DATA"],
              index: i,
              info: "Berhasil",
            });
          });
          t.validasiData();
          t.loadingTable = false;
        };
        // this.excelData = JSON.parse(JSON.stringify(tmp0));

        this.loadingTable = false;
        reader.readAsArrayBuffer(file);
      } catch (error) {
        console.log(error);
      }
    },
    validasiData() {
      for (let elm of this.excelData) {
        let find = this.dataBom.find((f) => f._X_ROW_KEY == elm.keyData);
        if (find) {
          find.kodeMaterial = elm.kodeMaterial;
          find.namaMaterial = elm.namaMaterial;
          find.style = elm.style;
          find.satuan = elm.satuan;
          find.color = elm.color;
          find.size = elm.size;
        }
      }
    },

    exportExcel() {
      let headers = [
        [
          "MATERIAL CODE",
          "MATERIAL DESCRIPTION",
          "MATERIAL UNIT",
          "MATERIAL STYLE",
          "MATERIAL COLOR",
          "MATERIAL SIZE",
          "QTY TOTAL",
          "KEY_DATA",
        ],
      ];

      this.dataBom.forEach((elm) => {
        let newArr = [
          elm.kodeMaterial,
          elm.namaMaterial,
          elm.satuan,
          elm.style,
          elm.color,
          elm.size,
          elm.total,
          elm._X_ROW_KEY,
        ];
        headers.push(newArr);
      });
      const data = XLSX.utils.aoa_to_sheet(headers);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, "Format Code Wo Revision CONSUMTION.xlsx");
    },
    addCost() {
      this.dataCost.push({
        costTitle: "",
        costMemo: "",
        costPrice: 0,
        costQty: 1,
      });
    },
    deleteCost(row) {
      this.dataCost = this.dataCost.filter(
        (f) => f._X_ROW_KEY != row._X_ROW_KEY
      );
    },
    async vgonewSelectedDataBaru(data) {
      this.loadingWait();
      let get = await this.$api.get(this.$serviceApiV2 + "/vgo/getdata", {
        params: {
          companyId: this.form.vgonewCompanyUuid,
          mclId: data.mcl[0].MCL_IDX,
        },
      });
      if (!get.data.data) {
        this.notifValidasi(this.$t("dataTidakAda"), true);
        this.loadingStop();
        return;
      }
      let res = get.data.data;
      let colors = res.color;
      for (let c of colors) {
        let orderQty = res.qty
          .filter((f) => f.color_uuid == c.uuid)
          .reduce((pv, cv) => {
            return pv + parseFloat(cv.qty);
          }, 0);
        let vgoElm = {
          kodeBarang: null,
          namaBarang: data.COVER_NAME,
          satuan: "PCE",
          qtyOrder: orderQty,
          price: 0,
          currency: "USD",
          brand: data.BRAND,
          spec: data.FB_TYPE,
          kategori: data.G_TYPE,
          gender: data.GENDER,
          color: c.color,

          season: data.SEASON,
          style: data.style,
          listKalkulasi: [],
        };
        //fabrid
        if (!res.fabric) res.fabric = [];
        LoopFabric: for (let fab of res.fabric) {
          if (fab.garment_color.length > 0) {
            let cek = fab.garment_color.find((f) => f == c.uuid);
            if (!cek) {
              continue LoopFabric;
            }
          }
          vgoElm.listKalkulasi.push({
            satuan: fab.uom,
            lost: parseFloat(fab.loss),
            qty: parseFloat(fab.net_yy),
            kodeMaterial: null,
            namaMaterial: fab.item_name,
            // kategori: fab.mtrlCate,
            kodeSupplier: fab.supplier,
            namaSupplier: fab.supplier,
            price: parseFloat(fab.unit_price),
            style: fab.itemNo,
            size: fab.cw_size,
            spec: fab.rd,
            color: fab.color,
          });
        }
        //asesoris
        if (!res.accessory) res.accessory = [];
        LoopAcc: for (let acc of res.accessory) {
          if (acc.garment_color.length > 0) {
            let cek = acc.garment_color.find((f) => f == c.uuid);
            if (!cek) {
              continue LoopAcc;
            }
          }
          vgoElm.listKalkulasi.push({
            satuan: acc.uom,
            lost: parseFloat(acc.loss),
            qty: parseFloat(acc.net_yy),
            kodeMaterial: null,
            namaMaterial: acc.item_name,
            // kategori: acc.mtrlCate,
            kodeSupplier: acc.supplier,
            namaSupplier: acc.supplier,
            price: parseFloat(acc.unit_price),
            style: acc.itemNo,
            size: acc.cw_size,
            spec: acc.rd,
            color: acc.color,
          });
        }
        //trim
        if (!res.trim) res.trim = [];
        LoopTrim: for (let tr of res.trim) {
          if (tr.garment_color.length > 0) {
            let cek = tr.garment_color.find((f) => f == c.uuid);
            if (!cek) {
              continue LoopTrim;
            }
          }
          vgoElm.listKalkulasi.push({
            satuan: tr.uom,
            lost: parseFloat(tr.loss),
            qty: parseFloat(tr.net_yy),
            kodeMaterial: null,
            namaMaterial: tr.item_name,
            // kategori: tr.mtrlCate,
            kodeSupplier: tr.supplier,
            namaSupplier: tr.supplier,
            price: parseFloat(tr.unit_price),
            style: tr.itemNo,
            size: tr.cw_size,
            spec: tr.rd,
            color: tr.color,
          });
        }
        this.baca.push(vgoElm);
      }
      let findCustomer = this.optionsCustomer.find((f) => f.text == data.BRAND);
      if (!findCustomer) {
        this.optionsCustomer.push({
          text: data.BRAND,
          value: data.BRAND,
          label: data.BRAND + "-" + data.BRAND,
        });
        this.form.kodeCustomer = data.BRAND;
      }
      this.susunDataBom();
      // this.vgonewTableConfig.tableData = get.data.data;
      this.vgonewModalDesign = false;
      this.loadingStop();
    },
    async vgonewSelectedData(data) {
      if (!this.form.vgonewCompanyUuid) {
        return this.notifValidasi("Silahkan Pilih Company List", true);
      }
      if (this.form.vgoType == "VGO BARU") {
        if (data.mcl.length <= 0) {
          return this.notifValidasi("CBD Tidak ditemukan", true);
        }
        this.vgonewSelectedDataBaru(data);
        return;
      }
      if (data.bomMclSelectDtoList.length <= 0) {
        return this.notifValidasi("CBD Tidak ditemukan", true);
      }
      this.loadingWait();

      let get = await this.$api.get(this.$serviceApiV2 + "/vgonew/getdata", {
        params: {
          companyId: this.form.vgonewCompanyUuid,
          mclId: data.bomMclSelectDtoList[0].mclUUID,
        },
      });
      if (get.data.data) {
        let datas = get.data.data;
        this.form.noPo = datas.mclBomSelectDto.designNo;
        this.baca = [];
        this.dataCost = [];

        let colors = datas.mclOrderQtySelectDtoList[0].colorQty.split("|$|");
        // let QTYS = datas.mclOrderQtySelectDtoList[1].colorQty.split("|$|");

        // let i = 0;
        let style = datas.mclStyleNoList.find((f) => f.isUse == "Y");
        if (style) {
          datas.style = style.styleNo;
        }

        for (let nd of colors) {
          let vgoElm = {
            kodeBarang: null,
            namaBarang: datas.mclBomSelectDto.coverName,
            satuan: "PCE",
            qtyOrder: datas.orderQty,
            price: datas.finalPrice,
            currency: datas.finalPriceUom == "$" ? "USD" : "",
            brand: datas.offerBrand,
            spec: datas.mclBomSelectDto.fabricType,
            kategori: datas.mclBomSelectDto.garmentType,
            gender: datas.mclBomSelectDto.gender,
            color: nd,
            // qtyOrder: QTYS[i],
            season:
              datas.mclBomSelectDto.year + "/" + datas.mclBomSelectDto.season,
            style: datas.style,
            listKalkulasi: [],
          };
          console.log(datas.mclPlanningSelectDtoList);
          for (let elm of datas.mclPlanningSelectDtoList.filter(
            (f) =>
              f.isUse == "Y" &&
              (f.dpdcyColor.includes(nd) || f.dpdcyColor == "")
          )) {
            vgoElm.listKalkulasi.push({
              size: elm.cw == "NA" ? null : elm.cw,
              satuan: elm.fwCwUom,
              lost: elm.loss,
              qty: elm.netYy,
              kodeMaterial: "",
              namaMaterial: elm.itemName,
              kategori: elm.mtrlCate,
              kodeSupplier: elm.spplrName,
              namaSupplier: elm.spplrName,
              price: elm.unitPrice,
              style: elm.itemNo,
              spec: elm.rdNo,
              color: elm.color == "NA" ? null : elm.color,
            });
          }
          // i += 1;
          // for (let cost of datas.cbdIncdtCostSelectDtoList.filter(
          //   (f) => f.isUse == "Y"
          // )) {
          //   this.dataCost.push({
          //     costTitle: cost.costType,
          //     costMemo: cost.costMemo,
          //     costQty: cost.qty,
          //     costPrice: cost.unitPrice,
          //   });
          // }
          console.log(vgoElm.listKalkulasi);
          this.baca.push(vgoElm);
        }
        let findCustomer = this.optionsCustomer.find(
          (f) => f.text == datas.mclBomSelectDto.offerBrand
        );
        if (!findCustomer) {
          this.optionsCustomer.push({
            text: datas.mclBomSelectDto.offerBrand,
            value: datas.mclBomSelectDto.offerBrand,
            label:
              datas.mclBomSelectDto.offerBrand +
              "-" +
              datas.mclBomSelectDto.offerBrand,
          });
          this.form.kodeCustomer = datas.mclBomSelectDto.offerBrand;
        }
      }

      this.susunDataBom();
      // this.vgonewTableConfig.tableData = get.data.data;
      this.vgonewModalDesign = false;
      this.loadingStop();
    },
    async vgonewSearchDesign() {
      if (!this.form.noPo) {
        return this.notifValidasi("Silahkan Ketik Nomor Design", true);
      }
      if (!this.form.vgonewCompanyUuid) {
        return this.notifValidasi("Silahkan Pilih Company List", true);
      }
      this.loadingWait();
      let get = {};
      if (this.form.vgoType == "VGO LAMA") {
        get = await this.$api.get(this.$serviceApiV2 + "/vgonew/filter", {
          params: {
            page: this.vgoPage,
            companyId: this.form.vgonewCompanyUuid,
            search: this.form.noPo,
          },
        });
      } else {
        get = await this.$api.get(this.$serviceApiV2 + "/vgo/filter", {
          params: {
            page: this.vgoPage,
            companyId: this.form.vgonewCompanyUuid,
            search: this.form.noPo,
          },
        });
      }
      // if (get.data.data.length <= 0) {
      //   this.loadingStop();
      //   return this.notifValidasi(
      //     "Data Design tidak ditemukan, silahkan periksa kembali",
      //     true
      //   );
      // }
      this.vgonewTableConfig.tableData = get.data.data;
      this.vgonewModalDesign = true;
      this.loadingStop();
    },
    footerMethod({ columns, data }) {
      const footerData = [
        columns.map((column, _columnIndex) => {
          if (_columnIndex === 0) {
            return "TOTAL";
          }
          if (["qtyOrder", "price", "amount"].includes(column.property)) {
            return this.$formatAmountBc(this.$$sumNum(data, column.property));
          }
          return null;
        }),
      ];
      return footerData;
    },
    susunDataBom() {
      this.dataBom = [];
      this.baca.forEach((elm) => {
        if (elm.isDeleted != true) {
          elm.listKalkulasi.forEach((elk) => {
            elk.rowHead = elm._X_ROW_KEY;
            elk.kodeBarang = elm.kodeBarang;
            elk.namaBarang = elm.namaBarang;
            elk.styleFg = elm.style;
            elk.colorFg = elm.color;
            elk.sizeFg = elm.size;
            elk.specFg = elm.spec;
            if (!elk.lost) elk.lost = 0;
            elk.total =
              (elm.qtyOrder * elk.qty * elk.lost) / 100 +
              elm.qtyOrder * elk.qty;
            elk.qtyOrder = elm.qtyOrder;
          });
          this.dataBom = [...this.dataBom, ...elm.listKalkulasi];
        }
      });
    },
    editMethodSelect({ row, column }) {
      const $table = this.$refs.xTable;
      // 重写默认的覆盖式，改为追加式
      $table.setActiveCell(row, column);
    },
    detailtoisdeletedTrue(row) {
      if (!row.id) {
        this.baca = this.baca.filter((f) => f._X_ROW_KEY != row._X_ROW_KEY);
      } else {
        if ((row.qtyFg && row.qtyFg > 0) || (row.qtyShip && row.qtyShip > 0)) {
          return this.notifValidasi(
            "Data ini sudah diproses tidak bisa dihapus"
          );
        }
        row.isDeleted = !row.isDeleted;
      }
      this.susunDataBom();
      // this.$refs.xTable.removeCheckboxRow();
    },
    async getBarang() {
      try {
        this.loadingTableBarang = true;
        const response = await this.$api.get(
          "api/v1/masterdata/barang/findbyjenisbc/page",
          {
            params: {
              search: this.searchBarang,
              jenisBc: "BARANG JADI",
              page: 0,
              pagelimit: 500,
            },
          }
        );
        // console.log(response);

        this.dataGetBarang = response.data.content.sort(
          this.compareValues("id", "desc")
        );
        this.loadingTableBarang = false;
      } catch (error) {
        this.loadingStop();
        this.notifikasiCustom("error", "ERROR", "Call Developer");
        console.log(error);
      }
    },
    querySearchCurrency(queryString, cb) {
      var links = this.optionsCurrency;
      var results = queryString
        ? links.filter(this.createFilterCurrency(queryString))
        : links;
      // call callback function to return suggestions
      cb(results);
    },
    createFilterCurrency(queryString) {
      return (link) => {
        return link.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1;
      };
    },
    querySearchSatuan(queryString, cb) {
      var links = this.optionsSatuan;
      var results = queryString
        ? links.filter(this.createFilterSatuan(queryString))
        : links;
      // call callback function to return suggestions
      cb(results);
    },
    createFilterSatuan(queryString) {
      return (link) => {
        return link.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1;
      };
    },
    async getSatuan() {
      const get = await this.$api.get("api/v1/masterdata/unit");

      this.optionsSatuan = [];
      get.data.forEach((elm) => {
        this.optionsSatuan.push({
          text: elm.kodeUnit,
          label: elm.kodeUnit,
          value: elm.kodeUnit,
        });
      });

      // console.log(this.optionsBrand);
    },
    deleteRow() {},
    setFormValue(data) {
      this.form = data;
      this.form.tanggal = new Date(data.tanggal);
      this.baca = data.listDetail || [];

      this.dataCost = data.listCost || [];
      this.susunDataBom();
    },

    getDataSelected() {
      // this.itemSelected = records;
    },
    checkMethodBaca({ row }) {
      return row.idPo == null;
    },

    async getCurrency() {
      const get = await this.$api.get("api/v1/masterdata/currency");

      this.optionsCurrency = [];
      get.data.forEach((elm) => {
        this.optionsCurrency.push({
          text: elm.currency,
          label: elm.currency,
          value: elm.currency,
        });
      });

      // console.log(this.optionsBrand);
    },
    blurCurrency(row) {
      if (row.currency == null) {
        row.currency = "";
      }
      let cek = this.optionsCurrency.filter(
        (f) => f.value.toLowerCase() == row.currency.toLowerCase()
      );
      if (cek.length <= 0) {
        row.currency = row.currency.toUpperCase();
        // return this.$notify({
        //   title: "WARNING",
        //   message: "Please input according to choice  ",
        //   offset: 200,
        //   type: "warning",
        // });
      } else {
        row.currency = cek[0].value;
      }
    },
    blurSatuan(row) {
      if (row.satuan == null) {
        row.satuan = "";
      }
      let cek = this.optionsSatuan.filter(
        (f) => f.value.toLowerCase() == row.satuan.toLowerCase()
      );
      if (cek.length <= 0) {
        row.satuan = row.satuan.toUpperCase();
        // return this.$notify({
        //   title: "WARNING",
        //   message: "Please input according to choice  ",
        //   offset: 200,
        //   type: "warning",
        // });
      } else {
        row.satuan = cek[0].value;
      }
    },
    totalEquals(row) {
      let price =
        row.price == null || row.price == undefined || isNaN(row.price)
          ? 0.0
          : parseFloat(row.price);

      row.amount = price * row.qtyOrder;
    },

    editMethodtambahan({ row, column }) {
      // 重写默认的覆盖式，改为追加式
      this.$refs.tableDokumentambahan.setActiveCell(row, column.property);
      // 返回 false 阻止默认行为
      return false;
    },
    editMethod({ row, column }) {
      // 重写默认的覆盖式，改为追加式
      this.$refs.xTable.setActiveCell(row, column.property);
      // 返回 false 阻止默认行为
      return false;
    },
    back() {
      this.$router.push("/marketing/wo");
    },
    hapusArray(tr) {
      this.baca = this.baca.filter((e) => {
        return e.id != tr;
      });
    },

    async getCustomer() {
      await this.$api
        .get("/api/v1/masterdata/customer")
        .then((response) => {
          Object.values(response.data).forEach((key) => {
            this.optionsCustomer.push({
              text: key.namaCustomer,
              value: key.kodeCustomer,
              label: `${key.kodeCustomer}-${key.namaCustomer}`,
            });
          });
          this.optionsCustomer = this.$$uniqueData(
            this.optionsCustomer,
            "value"
          );
        })
        .catch(() => {
          this.errored = true;
        });
    },
    async submitedData() {
      let customer = this.optionsCustomer.find(
        (f) => f.value == this.form.kodeCustomer
      );
      this.form.namaCustomer = customer ? customer.text : null;
      this.form.kodeCustomer = customer ? customer.value : null;
      try {
        this.form.isSaveKomposisi = this.isSaveKomposisi ? "y" : "n";
        this.form.isSaveDescription = this.isSaveDescription ? "y" : "n";
        this.form.listDetail = this.baca;
        this.form.listCost = this.dataCost;
        this.$emit("submitForm", this.form);
      } catch (error) {
        console.log(error);
        this.notifError(error.response.data);
        this.loadingStop();
      }
    },

    async handleSelected(tr = {}) {
      this.notifikasiCustom(
        "primary",
        "SELECTED",
        `DESCRIPTION: ${
          tr.namaBarang != undefined ? tr.namaBarang : tr.namaMaterial
        } CODE: ${
          tr.kodeMaterial == undefined ? tr.kodeBarang : tr.kodeMaterial
        }`
      );

      // this.baca = [];

      let barang = {
        ...tr,
      };
      if (this.selectIndex == null) {
        barang["qtyOut"] = 0;

        delete barang["id"];
        delete barang["_X_ROW_KEY"];

        //push ke kkomposisi ke data
        let komposisi = await this.$api.get(
          "api/v1/marketing/komposisi/filter",
          {
            params: {
              kodeBarang: barang.kodeBarang,
              styleFg: barang.style,
              colorFg: barang.color,
              sizeFg: barang.size,
              specFg: barang.spec,
            },
          }
        );
        komposisi.data.content.forEach((elm) => {
          delete elm.id;
          elm.kodeBarang = barang.kodeBarang;
          elm.namaBarang = barang.namaBarang;
          elm.satuanBarang = barang.satuan;
        });
        barang.listKalkulasi = komposisi.data.content;
        barang.currency = "";
        this.baca.push(barang);
        this.susunDataBom();
      } else {
        this.baca[this.selectIndex].kodeBarang = barang.kodeBarang;
        this.susunDataBom();
        // this.baca[this.selectIndex].brand = tr.brand;
        // this.baca[this.selectIndex].color = tr.color;
        // this.baca[this.selectIndex].hsCode = tr.hsCode;
        // this.baca[this.selectIndex].isDeleted = tr.isDeleted;
        // this.baca[this.selectIndex].isTransaction = tr.isTransaction;
        // this.baca[this.selectIndex].jenisBc = tr.jenisBc;
        // this.baca[this.selectIndex].kategori = tr.kategori;
        // this.baca[this.selectIndex].kodeBarang = tr.kodeBarang;
        // this.baca[this.selectIndex].kodeBarangJadi = tr.kodeBarangJadi;
        // this.baca[this.selectIndex].kodeBrand = tr.kodeBrand;
        // this.baca[this.selectIndex].kodeColor = tr.kodeColor;
        // this.baca[this.selectIndex].kodeColorBack = tr.kodeColorBack;
        // this.baca[this.selectIndex].kodeColorSurf = tr.kodeColorSurf;
        // this.baca[this.selectIndex].kodeKategori = tr.kodeKategori;
        // this.baca[this.selectIndex].kodeSatuan = tr.kodeSatuan;
        // this.baca[this.selectIndex].kodeSeason = tr.kodeSeason;
        // this.baca[this.selectIndex].kodeTipe = tr.kodeTipe;
        // this.baca[this.selectIndex].lebar = tr.lebar;
        // this.baca[this.selectIndex].model = tr.model;
        // this.baca[this.selectIndex].namaBarang = tr.namaBarang;
        // this.baca[this.selectIndex].namaColorBack = tr.namaColorBack;
        // this.baca[this.selectIndex].namaColorSurf = tr.namaColorSurf;

        // this.baca[this.selectIndex].pattern = tr.pattern;
        // // this.baca[this.selectIndex].price=tr.rice;
        // this.baca[this.selectIndex].remark = tr.remark;
        // this.baca[this.selectIndex].satuan = tr.satuan;
        // this.baca[this.selectIndex].season = tr.season;
        // this.baca[this.selectIndex].spec = tr.spec;
        // this.baca[this.selectIndex].style = tr.style;
        // this.baca[this.selectIndex].tebal = tr.tebal;
        // this.baca[this.selectIndex].tipeBarang = tr.tipeBarang;
        // this.baca[this.selectIndex].uom = tr.uom;
      }
    },
    async handleSelectedMaterial(tr = {}) {
      this.notifikasiCustom(
        "primary",
        "SELECTED",
        `DESCRIPTION: ${
          tr.namaBarang != undefined ? tr.namaBarang : tr.namaMaterial
        } CODE: ${
          tr.kodeMaterial == undefined ? tr.kodeBarang : tr.kodeMaterial
        }`
      );

      // this.baca = [];

      let barang = {
        ...tr,
      };

      this.dataBom[this.selectIndex].kodeMaterial = barang.kodeBarang;
      this.dataBom[this.selectIndex].namaMaterial = barang.namaBarang;
      this.susunDataBom();
    },
    getDataParents() {
      this.method();
    },
    acceptAlert() {
      // this.close();
      this.$vs.notify({
        color: "success",
        title: this.$t("berhasil"),
        text: this.$t("berhasilMenambahkanBarang"),
      });
    },
    close() {
      this.clearValMultiple();
      this.$vs.notify({
        color: "danger",
        title: this.$t("gagal"),
        text: this.$t("batalMenambahkanBarang"),
      });
    },
    clearValMultiple() {
      this.valMultipe.kodeBarang = "";
      this.valMultipe.namaBarang = "";
      this.valMultipe.kategori = "";
      this.valMultipe.jenis = "";
    },
    compareValues(key, order = "asc") {
      return function innerSort(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          // property doesn't exist on either object
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order === "desc" ? comparison * -1 : comparison;
      };
    },

    getDataSelectedPo({ records, row }) {
      this.baca = this.baca.filter((f) => f.idPo == null);
      records.forEach((e) => {
        let req = { ...e };
        req["idPo"] = e.id;
        req["qty"] = e.qty - e.qtyIn;
        req["request"] = e.noReg;

        delete req["_X_ROW_KEY"];
        delete req["id"];
        delete req["noReg"];
        this.baca.push(req);
      });

      this.$vs.notify({
        title: `CODE ${row.kodeBarang}`,
        text: `DESC: ${row.namaBarang} ${row.noReg}`,
      });
    },
    getDataSelectedPoAll({ checked, records }) {
      this.baca = this.baca.filter((f) => f.idPo == null);
      records.forEach((e) => {
        let req = { ...e };
        req["idPo"] = e.id;
        req["qty"] = e.qty - e.qtyIn;
        req["request"] = e.noReg;

        delete req["_X_ROW_KEY"];
        delete req["id"];
        delete req["noReg"];
        this.baca.push(req);
      });

      if (checked == true) {
        this.$vs.notify({
          title: ` SUCCESS`,
          text: `SELECTED ALL DATA `,
        });
      } else {
        this.$vs.notify({
          title: ` SUCCESS`,
          text: `CANCEL SELECTED ALL DATA `,
        });
      }
    },

    getUniqueListBy(arr, key) {
      return [...new Map(arr.map((item) => [item[key], item])).values()];
    },
    async vgonewCompany() {
      if (!this.form.integrasiVgonew) {
        return false;
      }
      let get = {};
      if (this.form.vgoType == "VGO LAMA") {
        get = await this.$api.get(this.$serviceApiV2 + "/vgonew/companylist");
        this.vgonewTableConfig.column = [
          {
            field: "designNo",
            key: "designNo",
            title: "DESIGN/NO PO",
            width: 100,
            align: "left",
          },
          {
            field: "style",
            key: "style",
            title: "STYLE",
            width: 100,
            align: "left",
          },
          {
            field: "offerBrand",
            key: "offerBrand",
            title: "BRAND/CUSTOMER",
            width: 100,
            align: "left",
          },
          {
            field: "bomYear",
            key: "bomYear",
            title: "YEAR BOM",
            width: 80,
            align: "left",
          },
          {
            field: "season",
            key: "season",
            title: "SEASON",
            width: 80,
            align: "left",
          },
          {
            field: "gender",
            key: "gender",
            title: "GENDER",
            width: 80,
            align: "left",
          },
          {
            field: "fabricType",
            key: "fabricType",
            title: "FABRIC TYPE",
            width: 80,
            align: "left",
          },
          {
            field: "orderType",
            key: "orderType",
            title: "ORDER TYPE",
            width: 80,
            align: "left",
          },
          {
            field: "coverName",
            key: "coverName",
            title: "COVER NAME",
            width: 150,
            align: "left",
          },
          {
            field: "sysUdtDt",
            key: "sysUdtDt",
            title: "MODIFIED DATE",
            width: 80,
            align: "left",
            format: "date",
          },
          {
            field: "workedBy",
            key: "workedBy",
            title: "WORKED BY",
            width: 80,
            align: "left",
          },
          {
            field: "status",
            key: "status",
            title: "STATUS",
            width: 80,
            align: "left",
          },
        ];
      } else {
        get = await this.$api.get(this.$serviceApiV2 + "/vgo/companylist");
        this.vgonewTableConfig.column = [
          {
            field: "DESIGN",
            key: "DESIGN",
            title: "DESIGN/NO PO",
            width: 100,
            align: "left",
          },
          {
            field: "style",
            key: "style",
            title: "STYLE",
            width: 100,
            align: "left",
          },
          {
            field: "BRAND",
            key: "BRAND",
            title: "BRAND/CUSTOMER",
            width: 100,
            align: "left",
          },
          {
            field: "BOM_YEAR",
            key: "BOM_YEAR",
            title: "YEAR BOM",
            width: 80,
            align: "left",
          },
          {
            field: "SEASON",
            key: "SEASON",
            title: "SEASON",
            width: 80,
            align: "left",
          },
          {
            field: "GENDER",
            key: "GENDER",
            title: "GENDER",
            width: 80,
            align: "left",
          },
          {
            field: "FB_TYPE",
            key: "FB_TYPE",
            title: "FABRIC TYPE",
            width: 80,
            align: "left",
          },
          {
            field: "ORDER_TYPE",
            key: "ORDER_TYPE",
            title: "ORDER TYPE",
            width: 80,
            align: "left",
          },
          {
            field: "COVER_NAME",
            key: "COVER_NAME",
            title: "COVER NAME",
            width: 150,
            align: "left",
          },
          {
            field: "MOD_DATE",
            key: "MOD_DATE",
            title: "MODIFIED DATE",
            width: 80,
            align: "left",
            format: "date",
          },
          {
            field: "WRITER",
            key: "WRITER",
            title: "WORKED BY",
            width: 80,
            align: "left",
          },
          {
            field: "STATUS_TEXT",
            key: "STATUS_TEXT",
            title: "STATUS",
            width: 80,
            align: "left",
          },
        ];
      }

      if (get.data.status == false) {
        return this.notifValidasi(get.data.message);
      }
      console.log(get.data.data);
      this.vgonewDataCompany = get.data.data;

      if (get.data.data.length > 0) {
        if (this.form.vgoType == "VGO LAMA") {
          this.form.vgonewCompanyUuid = get.data.data[0].cmpyUUID;
        } else {
          this.form.vgonewCompanyUuid = get.data.data[0].COMPANY_IDX;
        }
      }
    },
  },

  async mounted() {
    await this.settingCustomsColm();
    await this.getCustomer();
    await this.getSatuan();
    await this.getCurrency();

    // await this.getPurchasingheader();
    await this.getBarang();

    var date = new Date();
    var year = date.getFullYear();
    var month = (date.getMonth() + 1).toString().padStart(2, "0");
    var day = date.getDate().toString().padStart(2, "0");

    var hour = date.getHours();
    var minutes = date.getMinutes();
    var sec = date.getSeconds();

    var seedatetime = "WO-" + year + month + day + "-" + hour + minutes + sec;
    this.tglKeluar = year + "-" + month + "-" + day;
    this.noreg = seedatetime;
  },
};
</script>

<style>
.tengah {
  text-align: center;
  color: rgb(115, 103, 240);
}
#container {
  position: relative;
  width: 600px;
  height: 400px;
}
</style>
<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css" />
